import { useState, useEffect } from 'react';
import {
    Button,
    Text,
    IndexTable,
    useIndexResourceState,
    Badge,
    Thumbnail,
    Spinner,
    Popover,
    Card,
    Icon,
} from '@shopify/polaris';
import {
    CancelSmallMinor,
    NoteMajor,

} from '@shopify/polaris-icons';
import '../index.css';
import Language from '../../../../i18n/Language';
const t = Language;

const IndexTableMetaBox = (props) => {
    // 通信数据
    const {
        tabKey,
        loading,
        dataList,
        // total, 
        obj_name,
        headings,
        getTableItemState,
        promotedBulkActions,
        aloneBatchOpt,
        isShowProgress,

    } = props;

    const [isShowCompare, setIsShowCompare] = useState(-1); // 展示

    // 源文案
    const resourceName = {
        singular: 'dataList',
        plural: `${t(obj_name)}`,
    };

    const selectableOrders = dataList.filter((item) => !(item.disabled) && !(item.status === 2));
    const { selectedResources, allResourcesSelected, handleSelectionChange, clearSelection } = useIndexResourceState(selectableOrders);

    // 打开
    const handleOpenCompare = (item) => {
        setIsShowCompare(item.id);
    }
    // 关闭
    const handleCloseCompare = () => {
        setIsShowCompare(-1);
    }

    // 列表内容
    const TableDataList = dataList.map((item, index) => {
        return <IndexTable.Row
            id={item.id}
            key={item.id}
            selected={selectedResources.includes(item.id)}
            position={index}
            disabled={loading || item.disabled || item.status === 2}
        >
            <IndexTable.Cell>
                {
                    item.status === 2 ? <Thumbnail
                        source={NoteMajor}
                        size="small"
                        alt={""}
                    /> : <Thumbnail
                        source={item.img_src || NoteMajor}
                        size="small"
                        alt={item.img_src}
                    />
                }
            </IndexTable.Cell>
            <IndexTable.Cell><div className='limit_title_meta'>{item.title}</div></IndexTable.Cell>
            <IndexTable.Cell>
                <Badge tone={item.status === 0 ? 'success' : item.status === 2 ? '' : 'info'}>
                    {item.status === 0 ? t("Optimized") : item.status === 2 ? t("Deleted") : t("Restored")}
                </Badge>
            </IndexTable.Cell>
            <IndexTable.Cell>
                <Popover
                    active={isShowCompare === item.id}
                    activator={
                        <div className='limit_tags' onMouseEnter={() => handleOpenCompare(item)}>
                            {
                                !item.title_tag_before && !item.desc_tag_before && !item.title_tag_after && !item.desc_tag_after ? <>
                                    -
                                </> : <>
                                    <Text as="p" fontWeight="medium">{item.title_tag_before}</Text>
                                    <Text as="p" color="subdued">{item.desc_tag_before}</Text>
                                    <Text as="p" fontWeight="medium">{item.title_tag_after}</Text>
                                    <Text as="p" color="subdued">{item.desc_tag_after}</Text>
                                </>
                            }
                        </div>
                    }
                    onClose={handleCloseCompare}
                >
                    <div style={{ minWidth: '24rem' }} onClick={(e) => {
                        e.stopPropagation();
                    }} onMouseEnter={() => handleOpenCompare(item)} onMouseLeave={handleCloseCompare}>
                        <Card>
                            <div className='close_compare' onClick={(e) => {
                                e.stopPropagation();
                                handleCloseCompare();
                            }}><Icon source={CancelSmallMinor} color="base" /></div>
                            <Text as="p" fontWeight="medium">{t("Original meta tags")}:</Text>
                            {
                                !item.title_tag_before && !item.desc_tag_before ? <div className='empty_meta'>
                                    <Badge>{t("empty")}</Badge>
                                </div> : <div className='meta_compare_before'>
                                    <Text as="p" fontWeight="medium">{item.title_tag_before}</Text>
                                    <Text as="p" color="subdued">{item.desc_tag_before}</Text>
                                </div>
                            }
                            <br />
                            <Text as="p" fontWeight="medium">{t("Optimized meta tags")}:</Text>
                            {
                                !item.title_tag_after && !item.desc_tag_after ? <div className='empty_meta'>
                                    <Badge>{t("empty")}</Badge>
                                </div> : <div className='meta_compare_after'>
                                    <Text as="p" fontWeight="medium">{item.title_tag_after}</Text>
                                    <Text as="p" color="subdued">{item.desc_tag_after}</Text>
                                </div>
                            }
                        </Card>
                    </div>
                </Popover>
            </IndexTable.Cell>
            <IndexTable.Cell>
                <div className='flex_layout' style={{ columnGap: '1em' }}>
                    <div style={{ minWidth: '3rem' }}>{1 ? <Button
                        variant='plain'
                        disabled={Boolean(item?.is_restore) || item['id'] === item['optLoading']}
                        loading={item['id'] === item['restoreLoading']}
                        onClick={(e) => {
                            e.stopPropagation();
                            aloneBatchOpt(item, 'restore')
                        }}
                    >{t("Restore")}</Button> : <Spinner size='small' />}</div>
                    <div style={{ minWidth: '4rem' }}>{1 ? <Button
                        variant='plain'
                        disabled={Boolean(item?.is_re_optimize) || item['id'] === item['restoreLoading']}
                        loading={item['id'] === item['optLoading']}
                        onClick={(e) => {
                            e.stopPropagation();
                            aloneBatchOpt(item, 'optimize')
                        }}
                    >{t("Re-optimize")}</Button> : <Spinner size='small' />}</div>
                </div>
            </IndexTable.Cell>
        </IndexTable.Row>
    });

    useEffect(() => {
        getTableItemState([selectedResources, allResourcesSelected]); // 表格选择状态

    }, [selectedResources, allResourcesSelected]);

    useEffect(() => {
        return () => {
            clearSelection();
        }
    }, [tabKey, dataList, loading])

    return (
        <div className='index_table_box'>
            <IndexTable
                resourceName={resourceName}
                itemCount={dataList.length}
                selectedItemsCount={
                    allResourcesSelected ? 'All' : selectedResources.length
                }
                onSelectionChange={handleSelectionChange}
                hasMoreItems
                // hasZebraStriping
                promotedBulkActions={promotedBulkActions}
                headings={headings}
                selectable={isShowProgress !== tabKey}
            >
                {TableDataList}
            </IndexTable>
        </div>
    )
};


export default IndexTableMetaBox;